// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"121":"822f5b15","134":"31d6cfe0","576":"39388e5a","642":"2e037473"}[chunkId] + ".chunk.css";
};